export { ClassicLayout as Layout } from './ClassicLayout';
export { ClassicMinimalLayout as MinimalLayout } from './ClassicMinimalLayout';
export { ClassicButton as Button } from './ClassicButton';
export { ClassicPreviewImage as PreviewImage } from './ClassicPreviewImage';
